<template>
  <div
    class="input__errors"
  >
    <div v-if="validation && validation.$error">
      <div
        v-for="(param, object, index) in validation.$params"
        :key="index"
      >
        <p
          v-if="getViolationMessageCondition(param, object, validation)"
          class="input__error"
          v-text="getViolationMessage(param, object)"
        />
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'TgFormFieldValidation',
  props: {
    validation: {
      type: Object,
      default: null,
      required: true,
    },
    validationMessages: {
      type: Function,
      required: false,
      default: null,
    },
  },
  computed: {
    determinedViolationMessages () {
      const defaultTranslations = {
        email: this.$t('text.validation.email'),
        required: this.$t('text.validation.required'),
        minLength: this.$t('text.validation.min_length', { length: this.minLength || null }),
        maxLength: this.$t('text.validation.max_length', { length: this.maxLength || null }),
        sameAs: this.$t('text.validation.same_as', { same_as: this.sameAs }),
        validatePassword: this.$t('text.account.password_hint'),
        isValidCreditcardNumber: this.$t('text.validation.invalid_cc_number'),
      };

      if (typeof this.validationMessages === 'function') {
        this.validationMessages(defaultTranslations);
      }

      return defaultTranslations;
    },
    minLength () {
      const { $params } = this.validation;

      return $params && ('minLength' in $params) ? $params.minLength.min : '';
    },
    maxLength () {
      const { $params } = this.validation;

      return $params && ('maxLength' in $params) ? $params.maxLength.min : '';
    },
    sameAs () {
      const { $params } = this.validation;

      return $params && ('sameAs' in $params) ? $params.sameAs.eq : '';
    },
  },
  methods: {
    getViolationMessageCondition (param, object, value) {
      return !param ? !value[object] : param.type && !value[param.type];
    },
    getViolationMessage (param, object) {
      const key = param !== null && param.type ? param.type : object;

      if (key !== 'required') {
        return this.determinedViolationMessages[key];
      }

      return null;
    },
  },
};
</script>

<style scoped>
p {
  margin-bottom: 0;
}
</style>
